module.exports = __webpack_public_path__ + "img/vicon_rotaflow_ro_edw_geospread.f5dc9e67.jpg";